import React, { Component, FC } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Layout from 'components/v2/Layout/index';
import App from '../../../models/app';
import TileCard from './TileCard';
import { SortableList } from '../SortableList/index';
import theme from '../../../themes';
import { Link } from 'components/Common';
import i18n from '../../../i18n';
import { reorderTiles } from 'actions/gallery';

const Page = styled.div`
  background-color: #FFFFFF;
  box-sizing: border-box;
  min-height: 100%;
  width: 100%;
  overflow: hidden;
`;

const Subheader = styled.div`
  padding: 15px 15px 15px 10px;
  font-size: 18px;
  line-height: 24px;

  letter-spacing: -0.32px;

  color: #112530;
  border-bottom: 1px solid ${theme.borderColor};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0px 40px 0px;
`;

const ModalButton = styled(Link)`
  width: 30%;
  padding: 15px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  letter-spacing: 0;
  text-transform: uppercase;
  -webkit-tap-highlight-color: transparent;
  border-radius: 16px;
  font: 14px ${theme.fontSemibold};
  background-color: ${theme.fitbitDarkGreen};
  color: #ffffff;
`;

type ReduxProps = ReturnType<typeof mapDispatchToProps>;

interface ManageTilesProps extends ReduxProps {
  tiles: App[];
}

interface ManageTilesState {
  tiles: App[];
}

interface TilesContainer {
  tilesCount: number;
}

const Container: FC<TilesContainer> = ({ tilesCount, children }) => (
  <Layout
    name="Details"
    scrollKey="details"
    center={i18n('page.ManageTiles.title')({ tilesCount })}
    pageElement={<Page>{children}</Page>}
  />
);

class ManageTiles extends Component<ManageTilesProps, ManageTilesState> {
  constructor(props: ManageTilesProps) {
    super(props)

    this.state = {
      tiles: props.tiles
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if(prevProps.tiles.length > this.props.tiles.length) {
      const installedTilesIds = this.props.tiles.map((tile) => tile.id)
      const orderedTiles = prevState.tiles.filter((tile: App) => installedTilesIds.includes(tile.id))

      this.setState({ tiles: orderedTiles})
    }
  }

  updateTileOrder = async (oldIndex: number, newIndex: number) => {
    const tiles = [ ...this.state.tiles ]
    const el = tiles[oldIndex]

    // delete item from oldIndex
    tiles.splice(oldIndex, 1)
    
    // add item back
    tiles.splice(newIndex, 0, el)

    this.setState({
      tiles
    })

    await this.props.reorderTiles(tiles)
  }

  render() {
    const {
      tiles
    } = this.state

    return (
      <Container tilesCount={(tiles || []).length}>
        <SortableList 
          items={tiles} 
          displayFunc={(item: any) => <TileCard
              key={`tile-${item.id}`}
              tile={item}
              tileCount={tiles.length}
            />
          }
          updateOrder={(oldIndex: number, newIndex: number) => this.updateTileOrder(oldIndex, newIndex)}
        />
        <ButtonContainer>
          <ModalButton
            id={'add-tile-button'}
            aria-label={'add-tile-button'}
            to={'/v2/tiles/gallery'}
            pageDirection='FORWARD'
          >
            {i18n('page.ManageTiles.add')()}
          </ModalButton>
        </ButtonContainer>
      </Container> 
    )
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  reorderTiles: (tiles: any) => dispatch(reorderTiles(tiles)),
});

export default connect(null, mapDispatchToProps)(ManageTiles);
